export default {
  "首页": "होम पेज",
  "订单": "ऑर्डर",
  "新闻": "समाचार",
  "个人中心": "व्यक्तिगत केंद्र",
  "模拟账户": "डेमो खाता",
  "可用资产": "उपलब्ध संपत्ति",
  "入金": "जमा",
  "出金": "निकासी",
  "账单详情": "बिल विवरण",
  "重置模拟账户": "डेमो खाता रीसेट करें",
  "钱包": "वॉलेट",
  "实名认证": "सत्यापित पहचान",
  "邀请好友": "मित्रों को आमंत्रित करें",
  "修改密码": "पासवर्ड बदलें",
  "投诉邮箱": "शिकायत ईमेल",
  "其它": "अन्य",
  "公告": "घोषणाएँ",
  "语言": "भाषा",
  "是否退出登录": "क्या आप लॉगआउट करना चाहते हैं?",
  "复制": "कॉपी करें",
  "复制成功": "कॉपी सफल हुआ",
  "发送验证码成功": "सत्यापन कोड सफलतापूर्वक भेजा गया",
  "请输入密码": "कृपया पासवर्ड दर्ज करें",
  "请再次输入密码": "कृपया पासवर्ड दोबारा दर्ज करें",
  "复制邀请链接": "आमंत्रण लिंक कॉपी करें",
  "上传身份": "कृपया अपने पासपोर्ट/आईडी के दोनों तरफ़ की छवि अपलोड करें",
  "正面": "सामने का भाग",
  "上传正面": "पासपोर्ट/आईडी का सामने वाला भाग अपलोड करें",
  "反面": "पीछे का भाग",
  "上传反面": "पासपोर्ट/आईडी का पीछे वाला भाग अपलोड करें",
  "完善信息": "कृपया अपनी व्यक्तिगत जानकारी पूर्ण करें",
  "输入姓名": "कृपया अपना नाम दर्ज करें",
  "身份证号": "पासपोर्ट/आईडी नंबर",
  "输入身份证号": "कृपया अपना पासपोर्ट/आईडी नंबर दर्ज करें",
  "收款货币": "प्राप्ति मुद्रा",
  "银行名称": "बैंक का नाम",
  "收款人账户": "प्राप्तकर्ता खाता",
  "货币": "मुद्रा",
  "分店名称": "शाखा का नाम",
  "绑定银行卡": "बैंक कार्ड लिंक करें",
  "银行地址": "बैंक का पता",
  "账号名称（假名）": "खाता नाम (उपनाम)",
  "绑定数字货币地址": "क्रिप्टो मुद्रा पता लिंक करें",
  "余额": "शेष राशि",
  "联系客服": "ग्राहक सेवा से संपर्क करें",
  "行情": "बाज़ार",
  "其他": "अन्य",
  "设置": "सेटिंग",
  "收款人": "प्राप्तकर्ता",
  "添加": "जोड़ें",
  "确认": "पुष्टि करें",
  "取消": "रद्द करें",
  "钱包地址": "वॉलेट पता",
  "请输入": "कृपया दर्ज करें",
  "退出登录": "लॉगआउट करें",
  "充值数量": "जमा राशि",
  "提交": "जमा करें",
  "银行卡": "बैंक कार्ड",
  "选择网络": "नेटवर्क चुनें",
  "数字货币": "क्रिप्टो मुद्रा",
  "上传验证": "सत्यापन अपलोड करें",
  "提币地址": "निकासी पता",
  "数量(USD)": "राशि (USD)",
  "备注": "टिप्पणी",
  "手续费": "शुल्क",
  "预计到账数量": "अनुमानित राशि प्राप्ति",
  "暂无数据": "कोई डेटा नहीं है",
  "入金记录": "जमा रिकॉर्ड",
  "提币记录": "निकासी रिकॉर्ड",
  "验证码": "सत्यापन कोड",
  "邀请码": "आमंत्रण कोड",
  "提示": "सूचना",
  "请输入验证码": "कृपया सत्यापन कोड दर्ज करें",
  "姓名": "नाम",
  "邮箱登录": "ईमेल लॉगिन",
  "邮箱": "ईमेल",
  "密码": "पासवर्ड",
  "新用户": "नया उपयोगकर्ता",
  "立即加入": "अभी शामिल हों",
  "忘记密码": "पासवर्ड भूल गए",
  "登录": "लॉग इन करें",
  "无需开户,立即创建模拟账号进行交易!": "खाता खोलने की आवश्यकता नहीं है, व्यापार के लिए तुरंत डेमो खाता बनाएं!",
  "电话": "फोन",
  "再次输入密码": "पासवर्ड दोबारा दर्ज करें",
  "职业": "पेशा",
  "年收入": "वार्षिक आय",
  "注册": "पंजीकरण",
  "邮箱注册": "ईमेल पंजीकरण",
  "发送": "भेजें",
  "重置密码": "पासवर्ड रीसेट करें",
  "是否重置": "क्या आप रीसेट करना चाहते हैं?",
  "已重置": "रीसेट हो गया",
  "名称": "नाम",
  "注册成功": "पंजीकरण सफल हुआ",
  "加载中": "लोड हो रहा है",
  "您还未登录，请先登录": "आपने अभी तक लॉगिन नहीं किया है, कृपया पहले लॉगिन करें",
  "退出成功": "लॉगआउट सफल हुआ",
  "市价": "बाज़ार मूल्य",
  "挂单": "लिमिट ऑर्डर",
  "倍数": "गुणक",
  "止盈": "लाभ लें",
  "止损": "स्टॉप लॉस",
  "买入数量": "खरीद की मात्रा",
  "每手": "प्रति लॉट",
  "预估手续费": "अनुमानित शुल्क",
  "预估保证金": "अनुमानित मार्जिन",
  "买入": "खरीदें",
  "卖出": "बेचें",
  "您的订单已确认": "आपका आदेश पुष्टि हो गया है",
  "订单页面": "ऑर्डर पेज",
  "盈亏": "लाभ और हानि",
  "当前保证金": "वर्तमान मार्जिन",
  "订单详情": "ऑर्डर विवरण",
  "保证金": "मार्जिन",
  "平仓": "स्थिति बंद करें",
  "修改": "संशोधित करें",
  "手数": "लॉट",
  "暂无数据": "कोई डेटा उपलब्ध नहीं है",
  "历史": "इतिहास",
  "价格": "मूल्य",
  "请输入价格": "कृपया मूल्य दर्ज करें",
  "手": "लॉट",
  "搜索结果": "खोज परिणाम",
  "搜索产品": "उत्पाद खोजें",
  "持仓": "पोजीशन",
  "语言": "भाषा",
  "审核中": "समीक्षा में",
  "请上传证件照正/反面": "कृपया पहचान पत्र की सामने/पीछे की छवि अपलोड करें",
  "上传成功": "अपलोड सफल हुआ",
  "上传失败": "अपलोड असफल हुआ",
  "提交成功": "सफलतापूर्वक जमा हुआ",
  "删除": "हटाएं",
  "删除成功": "हटाना सफल हुआ",
  "提币": "निकासी",
  "缺少参数或传值错误": "पैरामीटर गायब हैं या मूल्य गलत है",
  "操作成功": "सफलतापूर्वक कार्य किया गया",
  "充值金额": "जमा राशि",
  "类型": "प्रकार",
  "状态": "स्थिति",
  "时间": "समय",
  "单位": "इकाई",
  "最高价": "सर्वोच्च मूल्य",
  "最低价": "न्यूनतम मूल्य",
  "开盘价": "खुलने का मूल्य",
  "请注册或登录真实账号": "कृपया एक असली खाता पंजीकृत करें या लॉग इन करें",
  "没有更多了": "और कुछ नहीं है",
  "提现金额": "निकासी राशि",
  "审核通过": "समीक्षा सफल",
  "审核不通过": "समीक्षा विफल",
  "重新提交": "पुनः सबमिट करें",
  "止盈价": "लाभ लेने की कीमत",
  "止损价": "स्टॉप लॉस कीमत",
  "总盈亏": "कुल लाभ और हानि",
  "撤单": "आदेश रद्द करें",
  "请先进行实名认证": "कृपया पहले सत्यापन पूरा करें",
  "产品列表": "उत्पाद सूची",
  "下单": "आदेश दें",
  "可用资金": "उपलब्ध धनराशि",
  "欢迎登录": "लॉग इन करने के लिए स्वागत है",
  "可用": "उपलब्ध",
  "冻结": "फ्रीज़",
  "财务记录": "वित्तीय रिकॉर्ड",
  "交易对": "व्यापार जोड़ी",
  "开仓时间": "ओपन पोजिशन का समय",
  "收益": "लाभ",
  "操作": "कार्य",
  "下单价": "आदेश मूल्य",
  "当前价": "वर्तमान मूल्य",
  "订单号": "ऑर्डर नंबर",
  "请选择": "कृपया चुनें",
  "卖出(做空)止损价不能低于开仓价": "बेचने (शॉर्ट) के लिए स्टॉप लॉस मूल्य खोलने की कीमत से कम नहीं हो सकता",
  "卖出(做多)止盈价不能高于开仓价": "बेचने (लॉन्ग) के लिए स्टॉप प्रॉफिट मूल्य खोलने की कीमत से अधिक नहीं हो सकता",
  "买入(做多)止损价不能高于开仓价": "खरीदने (लॉन्ग) के लिए स्टॉप लॉस मूल्य खोलने की कीमत से अधिक नहीं हो सकता",
  "买入(做多)止盈价不能低于开仓价": "खरीदने (लॉन्ग) के लिए स्टॉप प्रॉफिट मूल्य खोलने की कीमत से कम नहीं हो सकता",
  "买入(做多)止盈价不能低于开仓价和现价": "खरीदने (लॉन्ग) के लिए स्टॉप प्रॉफिट मूल्य खोलने की कीमत और वर्तमान कीमत से कम नहीं हो सकता",
  "买入(做多)止损价不能高于开仓价和现价": "खरीदने (लॉन्ग) के लिए स्टॉप लॉस मूल्य खोलने की कीमत और वर्तमान कीमत से अधिक नहीं हो सकता",
  "卖出(做空)止损价不能低于开仓价和现价": "बेचने (शॉर्ट) के लिए स्टॉप लॉस मूल्य खोलने की कीमत और वर्तमान कीमत से कम नहीं हो सकता",
  "卖出(做多)止盈价不能高于开仓价和现价": "बेचने (लॉन्ग) के लिए स्टॉप प्रॉफिट मूल्य खोलने की कीमत और वर्तमान कीमत से अधिक नहीं हो सकता",

  "提现手续费": "हटाएँगे हैंडलिंग फी",
  "提现退回": "विचड्रावेल पुनरावृत्ति",
  "系统加款": "सिस्टम जोड़ें",
  "系统减款": "तंत्र कमीकरण",

  "交易周期": "लेन-देन चक्र (लेनदेन चक्र, Len - den chakr)",
  "秒": "सेकंड (सेकेंड, Sekand)",
  "交易额": "लेन-देन की राशि (लेनदेन की राशि, Len - den ki rashi)",
  "买涨": "उछाल में खरीदना (उछाल में खरीदना, Uchhaal mein kharidna)",
  "买跌": "गिरावट में खरीदना (गिरावट में खरीदना, Giraavat mein kharidna)",
  "秒数": "सेकंड की संख्या (सेकेंड की संख्या, Sekand ki sankhya)",
  "交易类型": "लेन-देन का प्रकार (लेनदेन का प्रकार, Len - den ka prakaar)",
  "看涨": "उछाल की उम्मीद में (उछाल की उम्मीद में, Uchhaal ki ummeed mein)",
  "看跌": "गिरावट की उम्मीद में (गिरावट की उम्मीद में, Giraavat ki ummeed mein)",
  "剩余时间": "शेष समय (शेष समय, Shesh samay)",
  "买入价": "खरीद मूल्य (खरीद मूल्य, Kharid mulya)",
  "结算价": "निपटान मूल्य (निपटान मूल्य, Nipatan mulya)",
  "交易额": "लेन-देन की राशि (लेनदेन की राशि, Len - den ki rashi)",
  "下单时间": "ऑर्डर देने का समय (ऑर्डर देने का समय, Order dene ka samay)",
  "结算时间": "निपटान का समय (निपटान का समय, Nipatan ka samay)",
  "该币种暂无交易": "इस मुद्रा के लिए वर्तमान में कोई ट्रांसेक्शन नहीं है",

  "总资产": "कुल संपत्ति",
  "币种": "मुद्रा प्रकार",
  "资产折合": "संपत्ति का परिवर्तन",
  "冻结金额": "फ्रिज़ की गई राशि",
  "可用金额": "उपलब्ध राशि",
  "公司资产": "कंपनी की संपत्ति",
  "请输入旧密码": "कृपया पुराना पासवर्ड दर्ज करें",
  "请输入新密码": "कृपया नया पासवर्ड दर्ज करें",
  "请再次输入新密码": "कृपया नया पासवर्ड फिर से दर्ज करें",
  "白皮书": "सफेद पत्र",
  "注册证书": "पंजीकरण प्रमाणपत्र",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "उपरोक्त जानकारी का अंतिम व्याख्यान अधिकार आधिकारिक प्रतिष्ठान के पास है।",
  "上一页": "पिछला पेज",
  "下一页": "अगला पेज",
  "关闭": "बंद करें",
  "闪电兑换": "त्वरित विनिमय",
  "全部": "सभी",
  "可用余额": "उपलब्ध शेष राशि",
  "到": "तक",
  "请输入数量": "कृपया मात्रा दर्ज करें",
  "币种选择": "मुद्रा चयन",
  "从": "से",
  "兑换": "विनिमय",
  "兑换成功！": "विनिमय सफल हो गया!",
  "支付": "भुगतान",
  "全部兑换成功": "सभी विनिमय सफल हो गए",
  "获取": "प्राप्त करें",
  "数量": "मात्रा",
  "拒绝原因": "कारण अस्वीकार करें",
  "交易密码": "लेन-देन का पासवर्ड",
  "设置交易密码": "लेन-देन का पासवर्ड सेट करें",
  "重置交易密码": "लेन-देन का पासवर्ड रीसेट करें",
  "确定": "पुष्टि करें",
  "是否购买？": "खरीदें?",
  "外汇": "विदेशी मुद्रा",
  "期权": "विकल्प",
  "(用户中心)": "(उपयोगकर्ता केंद्र)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "आपका लेनदेन संसाधित किया जा रहा है, कृपया अन्य कार्य करने से पहले लेनदेन पूरा होने तक धैर्यपूर्वक प्रतीक्षा करें!",
  "继续下单": "ऑर्डर जारी रखें",
  "交易方向": "व्यापार दिशा",
  "实现盈利": "लाभ प्राप्त करें",
  "最新价格": "ताज़ा कीमत",
  "结算完成": "सेटलमेंट पूर्ण",
  "下单余额不足": "ऑर्डर करने के लिए अपर्याप्त शेष राशि",
  "输入交易额度": "लेन-देन की राशि दर्ज करें",
  "选择交易周期": "लेन-देन की अवधि चुनें",
  "审核拒绝": "समीक्षा अस्वीकृत",
  "请输入正确的数量!": "कृपया सही मात्रा दर्ज करें!",
  "上传身份": "पहचान पत्र अपलोड करें",
  "上传正面": "आगे का भाग अपलोड करें",
  "上传反面": "पीछे का भाग अपलोड करें",
  "完善信息": "जानकारी पूर्ण करें",
  "输入姓名": "नाम दर्ज करें",
  "输入身份证号": "पहचान संख्या दर्ज करें",
  "身份证号": "पहचान संख्या",
  "请上传证件照正/反面": "कृपया दस्तावेज़ का आगे/पीछे भाग अपलोड करें",
  "最小提现金额10USDT": "न्यूनतम निकासी राशि 10 USDT है",
  "证件号码": "पहचान संख्या",
  "输入证件号码": "पहचान संख्या दर्ज करें",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "कृपया पहचान सत्यापन के लिए अपना पहचान पत्र, ड्राइविंग लाइसेंस या पासपोर्ट अपलोड करें!"


}
